import * as React from 'react';

const PinIcon = () => (
  <svg width="58" height="70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M55.5 29.25c0 20.417-26.25 37.917-26.25 37.917S3 49.667 3 29.25a26.25 26.25 0 0 1 52.5 0Z"
      fill="#fff"
      stroke="#0050B4"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.25 38a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5Z"
      fill="#fff"
      stroke="#0050B4"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default PinIcon;
